import { useMemo } from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { AlertTriangle } from "lucide-react";

const DEFAULT_MESSAGE = "Sistema en mantenimiento. Por favor, intente más tarde.";

export default function MaintenancePage() {
  const message = useMemo(() => {
    return sessionStorage.getItem("maintenance_message") ?? DEFAULT_MESSAGE;
  }, []);

  const handleRetry = () => {
    window.location.href = "/";
  };

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-[var(--color-background)] px-4">
      <Card className="w-full max-w-xl border-0 shadow-2xl rounded-2xl overflow-hidden bg-white">
        <CardContent className="p-8 md:p-10">
          <div className="flex flex-col items-center text-center gap-4">
            <div className="w-14 h-14 rounded-full bg-amber-100 flex items-center justify-center">
              <AlertTriangle className="h-7 w-7 text-amber-600" />
            </div>
            <h1 className="text-2xl md:text-3xl font-semibold text-gray-900">
              Sistema en mantenimiento
            </h1>
            <p className="text-gray-600">
              {message}
            </p>
            <Button
              onClick={handleRetry}
              className="mt-2 bg-gradient-to-r from-[var(--color-primary)] to-[var(--color-secondary)] hover:scale-105 hover:text-white text-white font-semibold text-base transition-all duration-200 shadow-lg hover:shadow-xl"
            >
              Reintentar
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
